/**
 * Lightweight signup attribution. A `?ref=...` on any entry URL (e.g. the
 * "for gyms" CTA on a shared Glow Up → /pricing?ref=glowup) is stashed for the
 * session and sent with the eventual signup, so we can measure which signups
 * came from shared recaps.
 */
const KEY = 'tsf_ref';

export function captureRef(): void {
  try {
    const ref = new URLSearchParams(window.location.search).get('ref');
    if (ref) sessionStorage.setItem(KEY, ref.slice(0, 60));
  } catch {
    // sessionStorage unavailable (private mode) — attribution is best-effort
  }
}

export function getRef(): string | undefined {
  try {
    return sessionStorage.getItem(KEY) || undefined;
  } catch {
    return undefined;
  }
}
